export const removeInvalidSpecialCharacters = (inputValue: any): string => {
    const input = String(inputValue);
    const invalidCharacters = /[^\u0020-\u007E]/; // 키보드에 있는 ASCII 범위 이외의 문자 검사
    const controlCharacters = /[\u0000-\u001F\u007F]/; // 제어문자 검사
    const x0008Charactores = /_x0008_/g; // 백스페이스 문자 검사

    // invalidCharacters와 controlCharacters 패턴에 매치되는 문자열을 빈 문자열로 대체하여 반환

    return input.replace(x0008Charactores, "\b");
};
